import { Button } from "../../../../components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../../components/ui/dialog";
import { Input } from "../../../../components/ui/input";

/**
 * TemplateEditorDialog — Package B pack-slip template editor. Companion to
 * SlipTemplatesPanel; controls its own visibility via `!!templateDraft`.
 * Extracted from SellerDropship.jsx in Phase 3 refactor.
 */
export default function TemplateEditorDialog({
  templateDraft, setTemplateDraft, saveTemplateB, settings,
}) {
  return (
<Dialog open={!!templateDraft} onOpenChange={(v) => !v && setTemplateDraft(null)}>
  <DialogContent className="sm:max-w-[640px]" data-testid="template-dialog">
    <DialogHeader>
      <DialogTitle>{templateDraft?.id ? "Edit template" : "New pack-slip template"}</DialogTitle>
    </DialogHeader>
    {templateDraft && (
      <div className="grid grid-cols-2 gap-3 text-[12.5px]">
        <div className="col-span-2">
          <label className="text-[10.5px] mono uppercase tracking-[0.16em] text-foreground/55 block mb-1">Template name</label>
          <Input value={templateDraft.name} onChange={e => setTemplateDraft({ ...templateDraft, name: e.target.value })}
            data-testid="tpl-name" className="h-10"/>
        </div>
        <div className="col-span-2">
          <label className="text-[10.5px] mono uppercase tracking-[0.16em] text-foreground/55 block mb-1">Logo URL (optional)</label>
          <Input value={templateDraft.logo_url || ""} onChange={e => setTemplateDraft({ ...templateDraft, logo_url: e.target.value })}
            placeholder="https://…/logo.png" data-testid="tpl-logo" className="h-10"/>
        </div>
        <div>
          <label className="text-[10.5px] mono uppercase tracking-[0.16em] text-foreground/55 block mb-1">Accent colour</label>
          <div className="flex items-center gap-2">
            <input type="color" value={templateDraft.accent_color}
              onChange={e => setTemplateDraft({ ...templateDraft, accent_color: e.target.value })}
              data-testid="tpl-accent" className="h-10 w-14 rounded-lg border border-border bg-white p-1 cursor-pointer"/>
            <Input value={templateDraft.accent_color}
              onChange={e => setTemplateDraft({ ...templateDraft, accent_color: e.target.value })}
              className="h-10 mono flex-1"/>
          </div>
        </div>
        <div>
          <label className="text-[10.5px] mono uppercase tracking-[0.16em] text-foreground/55 block mb-1">Warehouse (optional)</label>
          <select value={templateDraft.warehouse_id || ""}
            onChange={e => setTemplateDraft({ ...templateDraft, warehouse_id: e.target.value || null })}
            data-testid="tpl-warehouse"
            className="w-full h-10 rounded-lg border border-border bg-white px-2 text-[12.5px]">
            <option value="">Global default</option>
            {settings.ship_from_addresses.map(a => (
              <option key={a.id} value={a.id}>{a.name || a.city || a.id}</option>
            ))}
          </select>
        </div>
        <div className="col-span-2">
          <label className="text-[10.5px] mono uppercase tracking-[0.16em] text-foreground/55 block mb-1">Header (HTML allowed)</label>
          <textarea value={templateDraft.header_html} onChange={e => setTemplateDraft({ ...templateDraft, header_html: e.target.value })}
            data-testid="tpl-header"
            className="w-full h-16 rounded-lg border border-border bg-white p-2 text-[12.5px] font-mono"/>
        </div>
        <div className="col-span-2">
          <label className="text-[10.5px] mono uppercase tracking-[0.16em] text-foreground/55 block mb-1">Footer</label>
          <Input value={templateDraft.footer_html} onChange={e => setTemplateDraft({ ...templateDraft, footer_html: e.target.value })}
            data-testid="tpl-footer" className="h-10"/>
        </div>
        <div className="col-span-2">
          <label className="text-[10.5px] mono uppercase tracking-[0.16em] text-foreground/55 block mb-1">Terms (small print at the bottom)</label>
          <textarea value={templateDraft.terms_html} onChange={e => setTemplateDraft({ ...templateDraft, terms_html: e.target.value })}
            data-testid="tpl-terms"
            className="w-full h-16 rounded-lg border border-border bg-white p-2 text-[12.5px]"/>
        </div>
        <div className="col-span-2 grid grid-cols-2 gap-2">
          {[
            { key: "show_barcodes",   label: "Code128 barcode" },
            { key: "show_vendor_sku", label: "Your (vendor) SKU column" },
            { key: "show_prices",     label: "Price column" },
            { key: "show_qty_check",  label: "Empty qty check-boxes" },
            { key: "is_default",      label: "Set as default template" },
          ].map(f => (
            <label key={f.key} className="flex items-center gap-2 h-10 px-3 rounded-lg border border-border bg-white cursor-pointer text-[12.5px]">
              <input type="checkbox"
                checked={!!templateDraft[f.key]}
                onChange={e => setTemplateDraft({ ...templateDraft, [f.key]: e.target.checked })}
                data-testid={`tpl-${f.key}`}
                className="w-4 h-4 accent-foreground"/>
              <span>{f.label}</span>
            </label>
          ))}
        </div>
        <div className="col-span-2">
          <Button onClick={saveTemplateB}
            data-testid="tpl-save"
            className="w-full h-10 rounded-full bg-foreground text-background hover:bg-foreground/90">
            Save template
          </Button>
        </div>
      </div>
    )}
  </DialogContent>
</Dialog>
  );
}
